<template>
  <div>
    <date-picker v-model="date" :config="datepickerOptions" placeholder="dd/mm/aaaa" :disabled="disabled"/>
  </div>
</template>

<script>
import { datepickerOptions } from '@/plugins'
import { set } from 'lodash'
import moment from 'moment'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    field: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      datepickerOptions: Object.assign({}, datepickerOptions, {
        format: 'DD/MM/YYYY',
        locale: 'pt-BR'
      }),
      date: ''
    }
  },

  created () {
    let self = this
    let date = new Date()
    let arr
    if (self.form.id) {
      if (self.field.indexOf('.')) {
        arr = self.field.split('.')
        if (arr.length === 1) {
          date = self.form[arr[0]] || ''
        } else if (arr.length === 2) {
          date = self.form[arr[0]][arr[1]] || ''
        } else if (arr.length === 3) {
          date = self.form[arr[0]][arr[1]][arr[2]] || ''
        }
      } else {
        date = self.form[self.field] || ''
      }
    }
    self.date = date ? this.convertDateToLocale(date) : ''
  },

  watch: {
    'date' (newVal) {
      if (newVal && newVal !== 'Invalid date') {
        const value = newVal.split('/').reverse().join('-')
        set(this.form, this.field, value)
        this.$emit('updateDate', this.form)
      }
    },
    form () {
      this.date = this.convertDateToLocale(this.form[this.field])
    }
  },

  methods: {
    convertDateToLocale (date) {
      const dateObj = new Date(date)
      const result = moment(dateObj).format('DD/MM/YYYY')
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/Datepicker.vue